import { object, string } from 'yup'
import { mixedShape } from 'utils/validation'

const BodySchema = {
  height: mixedShape.isHeightRealistic(),
  weight: mixedShape.isWeightRealistic()
}

export default BodySchema
